import protoRoot from "../proto-root";

const name = "changeCameraStationRecordingModeRpcResponse";

function create() {
  const ResultEnum = protoRoot.lookupEnum("Result");
  const ChangeCameraStationRecordingModeRPCResponse = protoRoot.lookupType(
    "comm.ChangeCameraStationRecordingModeRPCResponse"
  );
  const response = ChangeCameraStationRecordingModeRPCResponse.create({
    result: ResultEnum.values.SUCCESS
  });
  return { payload: response, name };
}

const changeCameraStationRecordingModeRpcResponse = { create, name };

export default changeCameraStationRecordingModeRpcResponse;
